// extracted by mini-css-extract-plugin
module.exports = {"collapse":"WalletFilterField_collapse__2RwGs","datepicker":"WalletFilterField_datepicker__366Oa"};